// extracted by mini-css-extract-plugin
export default {"container":"ImageCloze_container__tmpKv","content":"ImageCloze_content__tBIAO","gochi":"ImageCloze_gochi__b04Hm"};